// 订单操作日志实体
export interface OrderOperationLog {
  id: number;
  orderNo: string;
  module: string;
  action: string;
  operatorId: number;
  createdAt: string;
}

// 模块枚举
export enum OperationModule {
  Preprocessing = 'preprocessing',
  Audit = 'audit',
}

// 模块名称映射
export const OperationModuleNameMap: Record<string, string> = {
  [OperationModule.Preprocessing]: '预处理',
  [OperationModule.Audit]: '审核',
};

// 操作枚举
export enum OperationAction {
  // 预处理
  GetBuerData = 'preprocessing:get_buer_data',
  ToAudit = 'preprocessing:to_audit',
  DispatchDClass = 'preprocessing:dispatch_d_class',
  ShipIntercept = 'preprocessing:ship_intercept',
  LogisticsIntercept = 'preprocessing:logistics_intercept',
  Cancel = 'audit:cancel',
  CancelRevoke = 'default:cancel_revoke',
  SyncRrzuStatus = 'default:sync_rrzu_status',
  MarkGroupCreated = 'default:mark_group_created',

  // 审核
  LockAudit = 'audit:lock',
  ReleaseAudit = 'audit:release',
  Suspend = 'audit:suspend',
  AuditInterrupt = 'audit:interrupt',
  ResumeAudit = 'audit:resume',
  SubmitAudit = 'audit:submit',
  SubmitSupplement = 'audit:submit_supplement', // 提交补充材料
  SubmitPrepay = 'audit:submit_prepay', // 提交预收凭证
  Transfer = 'audit:transfer', // 转单
  ForceLockAudit = 'audit:force_lock', // 主管强制接单

  // 发货 (决策)
  SubmitDecisionReject = 'decision:reject',
  SubmitDecisionAdvance = 'decision:advance',
  SubmitDecisionSupplement = 'decision:supplement',
  SubmitDelivery = 'delivery:submit',
}

// 操作名称映射
export const OperationActionNameMap: Record<string, string> = {
  [OperationAction.GetBuerData]: '获取布尔数据',
  [OperationAction.ToAudit]: '提交审核',
  [OperationAction.ShipIntercept]: '发货拦截',
  [OperationAction.LogisticsIntercept]: '物流拦截',
  [OperationAction.Cancel]: '提交取消申请',
  [OperationAction.CancelRevoke]: '撤销取消',
  [OperationAction.SyncRrzuStatus]: '同步人人租状态',
  [OperationAction.MarkGroupCreated]: '标记建群',

  [OperationAction.LockAudit]: '接单并去审核',
  [OperationAction.ReleaseAudit]: '释放订单',
  [OperationAction.Suspend]: '暂存待办',
  [OperationAction.ResumeAudit]: '继续审核',
  [OperationAction.SubmitAudit]: '完成审核',
  [OperationAction.Transfer]: '审核转单',
  [OperationAction.SubmitDelivery]: '下发发货',
  [OperationAction.SubmitDecisionReject]: '取消订单',
  [OperationAction.SubmitDecisionAdvance]: '预收',
  [OperationAction.SubmitDecisionSupplement]: '补充材料',
};
